/**
 * Shared by the leadership dashboards (head teacher, Director of Studies):
 * the "Waiting for your decision" queues and the day formats they use.
 * Mirrors apps/dashboard/decisions.py.
 */

export interface Decision { key: string; label: string; count: number; note: string; link: string; urgent: boolean }

const date = (iso: string) => {
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const longDay = (iso: string) => date(iso).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
export const shortDay = (iso: string) => date(iso).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
export const percent = (value: number | null) => (value === null ? "—" : `${value.toLocaleString("en-GB", { maximumFractionDigits: 1 })}%`);

/** Waiting ones first, urgent before the rest, most waiting first; the empty ones keep their order at the end. */
export function orderDecisions(rows: Decision[]) {
  const waiting = rows.filter((row) => row.count > 0).sort((a, b) => Number(b.urgent) - Number(a.urgent) || b.count - a.count);
  return [...waiting, ...rows.filter((row) => row.count === 0)];
}
export const waitingTotal = (rows: Decision[]) => rows.reduce((sum, row) => sum + row.count, 0);

const VIEWERS: Record<string, string> = {
  admin: "an administrator", director: "the director", head_teacher: "the head teacher", director_of_studies: "the Director of Studies",
};

/** What the viewer is looking at, when the dashboard belongs to another role. */
export function viewerNote(role: string, owner: string, dashboard: string) {
  if (role === owner) return "";
  return `You are seeing ${dashboard} as ${VIEWERS[role] ?? role.replaceAll("_", " ")}. The decisions listed are the ones your own account may take, and appraisals are those assigned to you.`;
}
